const types = {
  LOAD_POKEMONS: "LOAD_POKEMONS",
  SAVE_POKEMONS: "SAVE_POKEMONS",
  POKEMONS_LOADING: "POKEMONS_LOADING",
  POKEMON_TYPES_LOADING: "POKEMON_TYPES_LOADING",
  LOAD_POKEMON_TYPES: "LOAD_POKEMON_TYPES",
  SAVE_POKEMON_TYPES: "SAVE_POKEMON_TYPES",
  FILTER_POKEMONS: "FILTER_POKEMONS",
  FETCH_POKEMON_DETAILS: "FETCH_POKEMON_DETAILS",
  SAVE_POKEMON_DETAILS: "SAVE_POKEMON_DETAILS",
  POKEMON_DETAILS_LOADING: "POKEMON_DETAILS_LOADING",
  POKEMONS_LOADING_ERROR: "POKEMONS_LOADING_ERROR",
};

export default types;
